module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/quantum-phone-video.96702b14.gif";